export default __webpack_public_path__ + "static/media/country.e7c6f866.png";